import req from '@/api/v1/request' // 引入封裝好的axios

// Login
export const apiLogin = (params) => req.post('auth/login', params)
// Logout
export const apiLogout = () => req.post('auth/logout')
// Auth Token
export const apiAuthToken = (token) => req.post(`auth/token/${token}`)
